import React from 'react'
import styled from 'styled-components'

import useIsMobile from '../../../../hooks/useIsMobile'

import MobileLayout from '../layoutMobile/MobileLayout'
import { BackContext, useBackState } from '../layoutMobile/BackContext'

const Layout = ({ children }) => {
	const isMobile = useIsMobile()
	const backState = useBackState()

	return (
		<BackContext.Provider value={backState}>
			{!isMobile ? (
				<Container>
					<Header>
						<Logo>Mi Portal Clínicas</Logo>
						<UserSection>

						</UserSection>
					</Header>
					<ContentWrapper>
						<MainContent>
							<ContainerChildren>{children}</ContainerChildren>
						</MainContent>
					</ContentWrapper>
				</Container>
			) : (
				<MobileLayout>{children}</MobileLayout>
			)}
		</BackContext.Provider>
	)
}

export default Layout

const Container = styled.div`
	min-height: 100vh;
	background-color: #f5f5f5;
`
const Header = styled.header`
	background-color: ${p => p.theme.colors.brand.blueOmint || '#003d82'};
	color: white;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	position: sticky;
	top: 0;
	z-index: 1000;
`

const Logo = styled.h1`
	font-size: 20px;
	font-weight: 600;
	margin: 0;
	color: white;
`

const UserSection = styled.div`
	position: relative;
`

const MainContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: 32px;
	background-color: #ffffff;
	@media (max-width: 768px) {
		padding: 16px;
	}
`
const ContainerChildren = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin: 0 55px;
	}
`

const ContentWrapper = styled.div`
	display: flex;
	min-height: calc(100vh - 64px);
`